import { Comment, Avatar, Rate, message } from "antd";
import { LikeOutlined, LikeFilled } from "@ant-design/icons";
import { useContext } from "react";
import { ReviewContext } from "../../lib/review-context";

export const SurveyResult = ({ review, placement }) => {
  const { id, name, stars, text, likes } = review;
  const { likeReview, hasLikedReview, submittedReview } =
    useContext(ReviewContext);

  const isReviewLiked = hasLikedReview(id);
  const isMyReview = id === submittedReview?.id;

  const like = () => {
    if (isMyReview) {
      message.info({
        content: "nice try lol thats your review",
        icon: <span style={{ marginRight: 5 }}>🤨</span>,
      });
      return;
    }
    if (isReviewLiked) {
      message.info({
        content: "bruh you already liked that",
        icon: <span style={{ marginRight: 5 }}>🙄</span>,
      });
      return;
    }
    likeReview(id, likes);
  };

  return (
    <Comment
      actions={[
        <span onClick={like}>
          {isReviewLiked || isMyReview ? <LikeFilled /> : <LikeOutlined />}
          <span style={{ marginLeft: 4 }}>{likes || 0}</span>
        </span>,
      ]}
      author={
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div style={{ marginRight: 12 }}>{name}</div>
          <div>
            <Rate disabled allowHalf value={stars} />
          </div>
        </div>
      }
      avatar={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <Avatar src={`https://joeschmoe.io/api/v1/${name}`} />
          </div>
          {placement}
        </div>
      }
      content={<p>{text}</p>}
    />
  );
};
